import { useState } from 'react';
import { getFooterIconCandidates } from '@/lib/storeBrand';

interface StoreFooterIconProps {
  config: any;
  store: any;
  alt: string;
  className?: string;
  wrapperClassName?: string;
}

export const StoreFooterIcon = ({
  config,
  store,
  alt,
  className = 'h-14 w-auto max-w-[180px] object-contain',
  wrapperClassName,
}: StoreFooterIconProps) => {
  const candidates = getFooterIconCandidates(config, store);
  const [index, setIndex] = useState(0);
  const [failed, setFailed] = useState(false);

  if (failed || candidates.length === 0 || index >= candidates.length) {
    return null;
  }

  const handleError = () => {
    if (index < candidates.length - 1) {
      setIndex((current) => current + 1);
      return;
    }
    setFailed(true);
  };

  const image = (
    <img
      src={candidates[index]}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{image}</div>;
  }

  return image;
};
